import { render, staticRenderFns } from "./RichTextRenderer.vue?vue&type=template&id=125822ac&scoped=true"
import script from "./RichTextRenderer.vue?vue&type=script&lang=js"
export * from "./RichTextRenderer.vue?vue&type=script&lang=js"
import style0 from "./RichTextRenderer.vue?vue&type=style&index=0&id=125822ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125822ac",
  null
  
)

export default component.exports